import {TariffTier} from "./tariff-tier";

export class ExtraSearchParams {
  length_groups?: number[];
  tariff_tier?: TariffTier
}
